import { shouldHaveFeature } from '@studio/feature.flags/featureFlags';

import { SET_FEATURE_FLAGS } from 'actions/Types';

/**
 *
 * TODO:
 *
 * 1. Consider putting the feature checking in middleware
 * 2. Merge previous state so you can set subsequent flags without overwriting
 */

export default function features(state = [], action) {
  if (action.type === SET_FEATURE_FLAGS) {
    return action.payload
      .map(feature => (shouldHaveFeature(feature) ? feature : false))
      .filter(f => f);
  }

  return state;
}
